<template>
  <div class="vue px-lg-4 timparty-featured-carousel featured-carousel">
    <LoaderOverlay v-if="loading"/>
<!--    <div class="featured-carousel-arrows d-flex align-items-center"  v-if="rewards && rewards.length > 1">-->
<!--      <div>-->
<!--        <ArrowLeft class="box-arrow" @click="sliderGoto('prev')"/>-->
<!--        <ArrowRight class="box-arrow" @click="sliderGoto()"/>-->
<!--      </div>-->
<!--    </div>-->
    <div class="featured-slider center-slider">
      <div class="slide" v-for="reward in rewards" v-bind:key="reward.benefitId">
        <div class="opaque-bg" v-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMED'"></div>
        <div class="opaque-bg" v-else-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'ENGAGEMENT'"></div>
        <div class="bg-white">
          <div class="porta-un-amico-card-background" v-bind:style="{ backgroundImage: 'url(' + reward.image + ')' }">
            <div class="porta-un-amico-card-amico p-2 text-center">
              <span><img class="icona-amico" :src="modulePath('js/src/assets/images/portaunamico-amico-white.png')"></span>
              <p class="text-amico" v-text="' AMICO ' + reward.requiredPoints"></p>
            </div>
<!--            <div v-if="reward.extra" class="porta-un-amico-card-extra p-2 text-center">-->
<!--              EXTRA-->
<!--            </div>-->
          </div>
          <div class="porta-un-amico-card-description p-3">
            <h4 v-html="reward.title"></h4>
            <p class="text-black" v-html="reward.description"></p>

<!--            <p v-text="initiative.userInformation.benefitStatus[reward.benefitId]"></p>-->
<!--            <p v-text="reward.benefitId"></p>-->

<!--            <button v-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMABLE'" class="btn btn-primary btn-block border-primary btn-disabled" disabled>GIÀ UTILIZZATO</button>-->
<!--            <button v-else-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMED'" class="btn btn-primary btn-block border-primary">RICHIEDI</button>-->
          </div>
          <div class="porta-un-amico-card-footer d-flex flex-column">
            <button v-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMED'" class="btn btn-primary btn-block border-primary btn-disabled mt-auto" disabled>GIÀ RICHIESTO</button>
              <p v-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMABLE'" class="gray-redeemable mb-0">
                Puoi richiederlo fino al {{ formatTimestamp(initiative.initiativeMgm.redeemEndTime) }}.
              </p>
              <button v-if="initiative.userInformation.benefitStatus[reward.benefitId] === 'REDEEMABLE'" class="btn btn-primary btn-block border-primary mt-auto" v-on:click="submitRedeemBenefit(reward.benefitId)">RICHIEDI</button>
          </div>
        </div>
      </div>
      <div class="slide bg-cover bg-dark" v-if="rewards.length === 0"></div>
    </div>
  </div>
</template>

<script>

/* eslint-disable */

import $ from 'jquery';
import 'slick-carousel';

import LoaderOverlay from './LoaderOverlay.vue'
import ArrowLeft from '../assets/images/arrow-white-left.svg';
import ArrowRight from '../assets/images/arrow-white-right.svg';
import TimPartyMixin        from '../mixins/TimPartyMixin';


export default {
  name: 'PortaUnAmicoCarousel',
  mixins: [ TimPartyMixin ],
  components: {
    ArrowLeft,
    ArrowRight,
    LoaderOverlay,
  },
  props: {
    rewards:{  // rewards - main object for this one, take prop from outside and parse them like the
      type: Array,
      // default: [
      //   {
      //     title: 'Benessere 2x1',
      //     description: 'fagsgawt afaw fawaf af aw faw aw faw aw faw awf aw awf aw faw wfw',
      //     buttonText: 'Scopri Di Piu',
      //     buttonState: 'disabled',
      //     backgroundImage: 'https://www.timparty.tim.it/sites/default/files/2022-04/TIM_MOMENTS_IMAGE.png',
      //     amico: true,
      //     extra: false
      //   },
      //   {
      //     title: 'Benessere 2x1',
      //     description: 'fagsgawt afaw fawaf af aw faw aw faw aw faw awf aw awf aw faw wfw',
      //     buttonText: 'Scopri Di Piu',
      //     buttonState: 'disabled',
      //     backgroundImage: 'https://www.timparty.tim.it/sites/default/files/2022-04/TIM_MOMENTS_IMAGE.png',
      //     amico: true,
      //     extra: true
      //   },
      //   {
      //     title: 'Benessere 2x1',
      //     description: 'fagsgawt afaw fawaf af aw faw aw faw aw faw awf aw awf aw faw wfw',
      //     buttonText: 'Scopri Di Piu',
      //     buttonState: 'disabled',
      //     backgroundImage: 'https://www.timparty.tim.it/sites/default/files/2022-04/TIM_MOMENTS_IMAGE.png',
      //     amico: true,
      //     extra: true
      //   },
      //   {
      //     title: 'Benessere 2x1',
      //     description: 'fagsgawt afaw fawaf af aw faw aw faw aw faw awf aw awf aw faw wfw',
      //     buttonText: 'Scopri Di Piu',
      //     buttonState: 'disabled',
      //     backgroundImage: 'https://www.timparty.tim.it/sites/default/files/2022-04/TIM_MOMENTS_IMAGE.png',
      //     amico: true,
      //     extra: true
      //   },
      //   {
      //     title: 'Benessere 2x1',
      //     description: 'fagsgawt afaw fawaf af aw faw aw faw aw faw awf aw awf aw faw wfw',
      //     buttonText: 'Scopri Di Piu',
      //     buttonState: 'disabled',
      //     backgroundImage: 'https://www.timparty.tim.it/sites/default/files/2022-04/TIM_MOMENTS_IMAGE.png',
      //     amico: true,
      //     extra: true
      //   }
      // ]
    },
    apiUrl: {
      type: String,
      default: '/api/mgm/handleAction',
    }
  },
  data: function(){

    return {
      initiative: '',
      refereeBenefit: '',
    };
  },
  mounted: function(){
    this.setApiUrl(this.apiUrl);

    let modal = this.$root.$refs.PortaUnAmico.getInfoModal();

    setTimeout(()=>{
      this.initiative = this.mgm_initiative;
      this.refereeBenefit = this.$root.$refs.PortaUnAmico.setRefereeBenefitChild();
    },1500);
    // setTimeout(()=>{
    //   modal.show = true;
    //   modal.link_redirect = '/party-collection-5';
    //   this.$root.$refs.PortaUnAmico.setInfoModal(modal);
    // },5000);
  },
  methods: {
    themePath: function( path ){
      return '/themes/custom/timparty/' + path;
    },

    activateSlider: function() {
      if (this.rewards.length > 0) {
        this.$nextTick(function () {

          $('.featured-slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerMode: true,
                  dots: false,
                  arrows: false
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: true,
                  prevArrow: '<button class="slide-arrow prev-arrow"><img src="' + this.modulePath('js/src/assets/images/portaunamico-arrow-left.png') + '"></button>',
                  nextArrow: '<button class="slide-arrow next-arrow"><img src="' + this.modulePath('js/src/assets/images/portaunamico-arrow-right.png') + '"></button>'
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1.5,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: true,
                  prevArrow: '<button class="slide-arrow prev-arrow"><img src="' + this.modulePath('js/src/assets/images/portaunamico-arrow-left.png') + '"></button>',
                  nextArrow: '<button class="slide-arrow next-arrow"><img src="' + this.modulePath('js/src/assets/images/portaunamico-arrow-right.png') + '"></button>'
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: true,
                  prevArrow: '<button class="slide-arrow prev-arrow"><img src="' + this.modulePath('js/src/assets/images/portaunamico-arrow-left.png') + '"></button>',
                  nextArrow: '<button class="slide-arrow next-arrow"><img src="' + this.modulePath('js/src/assets/images/portaunamico-arrow-right.png') + '"></button>'
                }
              }
            ]
          });
        })
      }
    },

    sliderGoto: function(dir){

      if(dir == 'prev'){
        $('.featured-slider').slick('slickPrev');
      }
      else{
        $('.featured-slider').slick('slickNext');
      }
    },

    submitRedeemBenefit: function(benefitId) {
      $(this).attr('disabled', 'disabled');
      let self = this;
      let payload = {
        action: 'redeemBenefit',
        benefit_id: benefitId,
      };

      this.callApi(payload, function(response) {
        if (response.success) {
          let benefit = self.$root.$refs.PortaUnAmico.getBenefitByBenefitId(benefitId);
          let url = benefit.urlCta;
          if (benefit.templateCode === 'MGM_BENEFIT_SIMPLE' || benefit.templateCode === 'MGM_BENEFIT_REFEREE_SIMPLE') {
            window.location.href = url;
          } else if (benefit.templateCode === 'MGM_BENEFIT_BADGE_POPUP') {
            self.dispatchUpdateBadges();

            let modal = self.$root.$refs.PortaUnAmico.getInfoModal();
            $('body #link-badge').attr('href', url);
            modal.show = true;
            self.$root.$refs.PortaUnAmico.setInfoModal(modal);
          }
          self.dispatchMGMInitiative();

        } else {
          console.log('ko');
        }
      });
    },
  },
  watch: {
    initiative() {
      let self = this;

      this.rewards = this.initiative.initiativeMgm.benefitList.filter(function (reward) {
        let keys = Object.keys(self.initiative.userInformation.benefitStatus);
        return keys.includes(String(reward.benefitId)) && !reward.isBenefitReferee;
        // return keys.includes(String(reward.benefitId));
      });
    },
    rewards() {
      this.activateSlider();
    },
    mgm_initiative() {
      this.initiative = this.mgm_initiative;
    }
  }
}
</script>


